import { useCallback, useContext, useState } from 'react';

import HealthcareSystemInput from './HealthcareSystemInput';
import HealthcareSystemNameInput from './HealthcareSystemNameInput';
import IntakeInpatientCareCheck from './IntakeInpatientCareCheck';
import NoInpatientCareWarning from './NoInpatientCareWarning';
import ExistingPartnerSelect from '../common/ExistingPartnerSelect';
import NewPartnerSection from '../common/IntakeNewPartnerSection';
import NewPartnerSectionHeader from '../common/IntakeNewPartnerSectionHeader';
import IntakePrimaryContact from '../common/IntakePrimaryContact';
import RowWrap from '../common/IntakeRowWrap';
import IntakeShippingContact from '../common/IntakeShippingContact';
import IntakeSubmitButton from '../common/IntakeSubmitButton';
import NewPartnerCheckbox from '../common/NewPartnerCheckbox';
import PartnerCategoryInput from '../common/PartnerCategoryInput';
import PartnerNameInput from '../common/PartnerNameInput';
import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';
import { IntakeResponse } from '@/models/IntakeResponse';
import { UsersContext } from '@/Contexts/UsersContext';
import { ProgramProps } from '@/models/Program';

function TreeCampusHealthcareSignUp({
  selectedProgramInfo,
  onSubmit,
}: {
  selectedProgramInfo: ProgramProps;
  onSubmit: (intakeResponse: IntakeResponse) => void;
}) {
  const { isNewPartner, disabledNewPartnerCheckbox, partnerInfo } =
    useContext(PartnerIntakeContext);
  const [inpatientCareProvided, setInpatientCareProvided] = useState<boolean | null>(null);
  const { userCurrent } = useContext(UsersContext);

  const handleProvidesInpatientChange = useCallback((newValue: boolean | null) => {
    setInpatientCareProvided(newValue);
  }, []);

  return (
    selectedProgramInfo && (
      <>
        <IntakeInpatientCareCheck
          inpatientCareProvided={inpatientCareProvided}
          onChange={handleProvidesInpatientChange}
        />
        {inpatientCareProvided === false && <NoInpatientCareWarning />}
        {inpatientCareProvided === true && (
          <>
            <IntakePrimaryContact />

            {!isNewPartner && <ExistingPartnerSelect />}

            {!disabledNewPartnerCheckbox && <NewPartnerCheckbox />}

            {isNewPartner && (
              <NewPartnerSection>
                <NewPartnerSectionHeader />

                {selectedProgramInfo?.displayCategory == 1 && <PartnerCategoryInput />}

                <PartnerNameInput />

                {userCurrent?.partnerGroupId == null && (
                  <RowWrap>
                    <HealthcareSystemInput />
                    {partnerInfo?.healthcareSystem === true ? <HealthcareSystemNameInput /> : <></>}
                  </RowWrap>
                )}

                <IntakeShippingContact />
              </NewPartnerSection>
            )}
            <IntakeSubmitButton onSubmit={onSubmit} />
          </>
        )}
      </>
    )
  );
}

export default TreeCampusHealthcareSignUp;
